import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { userPassword } from "../redux/thunks/User";
import AlertBox from "../components/common/AlertBox";
import Input from "../components/sub-component/Input";
import { getResource } from "../redux/thunks/Resource";
import Button from "../components/sub-component/Button";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import { ReactComponent as TestFuseWatermarkIcon } from "../assets/icons/candidate-assessment/Watermark Light.svg";

function PasswordSetUp({ assessment, access_token }) {
  const dispatch = useDispatch();
  const [icon, setIcon] = useState();
  const [alert, setAlert] = useState(null);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    confirm_password: "",
  });
  const [processing, setProcessing] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const [hideConfirmPassword, setHideConfirmPassword] = useState(true);

  const handleChange = (fieldName, event) => {
    let value = event.target.value;
    if (fieldName === "email") {
      value = event.target.value.trim();
    }
    setCredentials({ ...credentials, [fieldName]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setProcessing(true);
      const dispatched = await dispatch(
        userPassword({ password: credentials.password, access_token })
      );
      setProcessing(false);

      if (dispatched.error) {
        setAlert(
          <AlertBox
            description={`${dispatched.error.message}!`}
            color="danger"
            title="Error"
            onCloseAlert={() => {
              setAlert(null);
            }}
          />
        );
        return;
      }
      setAlert(
        <AlertBox
          description="Profile updated successfully!"
          color="success"
          title="Success"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />
      );
      window.location.replace("/dashboard/assessments");
    } catch (error) {
      setProcessing(false);
      setAlert(
        <AlertBox
          description={`Error occurred: ${error.message}`}
          color="danger"
          title="Error"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />
      );
    }
  };

  // useEffect(() => {
  //   (async () => {
  //     if (assessment?.tenant?.image_id) {
  //       const imageResult = await dispatch(
  //         getResource({ id: assessment?.tenant?.image_id })
  //       );
  //       if (!imageResult.error) {
  //         setIcon(imageResult.payload.url);
  //       }
  //     }
  //   })();
  // }, [assessment?.tenant?.image_id]);

  return (
    <>
      {alert}
      <div
        className="candidate-invite-main-container"
        style={{
          width: isOnMobileScreen ? "100%" : "calc(100% + 50px)",
          margin: isOnMobileScreen ? "0px" : "-24px",
        }}
      >
        <div className="candidate-invite-container" style={{ height: "auto" }}>
          {/* <div className="assessment-header">
            {icon ? (
              <img className="assessment-header-icon" src={icon} alt="" />
            ) : (
              <div className="assessment-header-icon-initial">
                <span className="body-1 white">
                  {(
                    assessment?.tenant?.company_name?.slice(
                      0,
                      2
                    ) || ""
                  ).toUpperCase()}
                </span>
              </div>
            )}
            <span className="headline-1 dark-100">
              {assessment?.tenant?.company_name}
            </span>
          </div> */}
          <span className="headline-3 text-start">Set up password</span>
          <form
            className="d-flex flex-column"
            style={{
              width: !isOnMobileScreen ? "508px" : "100%",
              gap: "24px",
              marginTop: "-12px",
            }}
            onSubmit={handleSubmit}
          >
            <div className="d-flex flex-column">
              <Input
                placeholder="Email"
                varrient={"primary"}
                onChange={(e) => handleChange("email", e)}
                type={"text"}
                title={"Email"}
                value={assessment?.email}
                onBoardingInput
              />
            </div>
            <div className="d-flex flex-column">
              <Input
                name={"password"}
                placeholder="Password"
                varrient={"primary"}
                title={"Password"}
                onChange={(e) => handleChange("password", e)}
                type={hidePassword ? "password" : "text"}
                value={credentials.password}
                enableRevealIcon={true}
                revealPasswordClick={() => setHidePassword(!hidePassword)}
              />
            </div>
            <div className="d-flex flex-column">
              <Input
                placeholder="Confirm Password"
                name={"confirm_password"}
                varrient={"primary"}
                title={"Confirm Password"}
                onChange={(e) => handleChange("confirm_password", e)}
                type={hideConfirmPassword ? "password" : "text"}
                value={credentials.confirm_password}
                enableRevealIcon={true}
                revealPasswordClick={() =>
                  setHideConfirmPassword(!hideConfirmPassword)
                }
              />
            </div>
            <div className="w-100 d-flex">
              <Button
                btn="ragular-btn"
                varrient="primary"
                textClass="body-1"
                processing={processing}
                type={"submit"}
                title={"Save"}
                style={{ width: "100%", height: "40px" }}
              />
            </div>
          </form>
        </div>
        <div className="watermark mt-3">
          <TestFuseWatermarkIcon style={{ height: "50px" }} />
        </div>
      </div>
    </>
  );
}

export default PasswordSetUp;
